<h2 mat-dialog-title>Confirmation?</h2>
<mat-dialog-content>
    <p>Changes you made may not be saved. Do you want to save?</p>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: flex-end;">
    <button class="noBtn" mat-button (click)="onNoClick()">No</button>&nbsp;
    <button class="yesBtn" mat-button (click)="yes()">Yes</button>
</mat-dialog-actions>